const styles = theme => ({
  root: {
    padding: theme.spacing(0, 0, 2, 0),
    maxWidth: '450px',
  },
})

export default styles
